import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    template: `<router-outlet></router-outlet>`
})
export class RootComponent {}


// WEBPACK FOOTER //
// D:/OficinaVirtual/FrontEndFinnecta/EFactoringManager/src/root.component.ts